<template>
  <div>
    <div class="inner">
      <mobile-control v-if="isMobile"></mobile-control>
      <pc-control v-if="!isMobile"></pc-control>
    </div>
  </div>
</template>
<script>
import MobileControl from './examintro/mobile'
import PcControl from './examintro/pc'
export default {
  components:{
    MobileControl,PcControl
  },
  data() {
    return {
      isMobile: false
    }
  },
  computed: {
    device() {
      return this.$store.state.app.device
    }
  },
  created() {
    this.isMobile = this.device
  },
  watch:{
    device(val){
      this.isMobile = val
    }
  }
}
</script>
<style scoped>

.inner{
  margin: auto;
    position: relative;
}
</style>


// WEBPACK FOOTER //
// src/components/home/examintro.vue